import MaterialAssessmentSurveyBase from '../../../components/MaterialAssessmentSurveyBase/MaterialAssessmentSurveyBase';
import { MATERIAL_ASSESSMENT_PAGE_CONFIGS } from '../../../constants/materialAssessment';

function MaterialityAssessmentSurvey() {
  return <MaterialAssessmentSurveyBase config={MATERIAL_ASSESSMENT_PAGE_CONFIGS.SURVEY} />;
}

export default MaterialityAssessmentSurvey;
